// extracted by css-extract-rspack-plugin
export default {"Breadcrumb":"Breadcrumb-i_YsuO","breadcrumb":"Breadcrumb-i_YsuO"};